<button nz-button nz-dropdown [nzDropdownMenu]="menu" [nzClickHide]="false">
  {{ "word.select_option.placeholder.view" | translate }}
</button>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li *ngFor="let item of options" nz-menu-item>
      <v4-selectable-menu-item [checked]="checkedValues.has(item.value)" (click)="onCheck(item)">{{
        item.label
      }}</v4-selectable-menu-item>
    </li>
  </ul>
</nz-dropdown-menu>
